module.exports = "/fonts/vendor/@fortawesome/fontawesome-free/webfa-brands-400.ttf?60127e352b7a11f7f1bc22decf628ed2";